/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScheduleSupplementsAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  SUPPLEMENTS_SCHEDULE_CONTENT_AUTOCOMPLETE = 'supplements-schedule-content-autocomplete',
  SUPPLEMENTS_SCHEDULE_CONTENT_AUTOCOMPLETE_FETCH = 'supplements-schedule-content-autocomplete-fetch',
  SUPPLEMENTS_SCHEDULE_CONTENT_AUTOCOMPLETE_FIELD = 'supplements-schedule-content-autocomplete-field',
  SUPPLEMENTS_SCHEDULE_CONTENT_AUTOCOMPLETE_MAPPER = 'supplements-schedule-content-autocomplete-mapper',
  SUPPLEMENTS_SCHEDULE_CONTENT_AUTOCOMPLETE_TEXT = 'supplements-schedule-content-autocomplete-text',
  SUPPLEMENTS_SCHEDULE_CONTENT_FIELD = 'supplements-schedule-content-field',
  SUPPLEMENTS_SCHEDULE_CONTENT_FORM = 'supplements-schedule-content-form',
  SUPPLEMENTS_SCHEDULE_CONTENT_FORM_FIELD = 'supplements-schedule-content-form-field',
  SUPPLEMENTS_SCHEDULE_CONTENT_FORM_PANEL = 'supplements-schedule-content-form-panel',
  SUPPLEMENTS_SCHEDULE_CONTENT_PANEL = 'supplements-schedule-content-panel',
  SUPPLEMENTS_SCHEDULE_CONTENT_TEXT = 'supplements-schedule-content-text',
  SUPPLEMENTS_SCHEDULE_CONTENT_TEXT_AREA = 'supplements-schedule-content-text-area',
  SUPPLEMENTS_SCHEDULE_CONTENT_TEXT_AREA_FIELD = 'supplements-schedule-content-text-area-field',
  SUPPLEMENTS_SCHEDULE_INPUT_DATE_TIME_FIELD = 'supplements-schedule-input-date-time-field',
  SUPPLEMENTS_SCHEDULE_LAYOUT = 'supplements-schedule-layout',
}
export { ScheduleSupplementsAliases };
